import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

interface RevealKeyDialogProps {
  isOpen: boolean;
  onClose: () => void;
  providerName: string | null;
  revealedKey: string | null;
}

export function RevealKeyDialog({
  isOpen,
  onClose,
  providerName,
  revealedKey,
}: RevealKeyDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>API Key for {providerName}</DialogTitle>
          <DialogDescription>This is sensitive. Close when done.</DialogDescription>
        </DialogHeader>
        {revealedKey ? (
          <div className="bg-gray-50 p-4 rounded font-mono text-sm break-all">{revealedKey}</div>
        ) : (
          <div className="text-center py-4 text-muted-foreground">Loading...</div>
        )}
        <DialogFooter>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
